(() => {
  const desktopBreakpoint = window.matchMedia('(min-width: 990px)');

  const initializeHeader = (header) => {
    if (header.dataset.mobileHeaderInitialized === 'true') return;

    const button = header.querySelector('[aria-controls="menu-drawer"]');
    const menu = header.querySelector('#menu-drawer');

    if (!button || !menu) return;

    header.dataset.mobileHeaderInitialized = 'true';

    const closeMenu = ({ restoreFocus = false } = {}) => {
      button.setAttribute('aria-expanded', 'false');
      menu.hidden = true;

      if (restoreFocus) button.focus();
    };

    const openMenu = () => {
      button.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      menu.querySelector('a')?.focus();
    };

    button.addEventListener('click', () => {
      if (button.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      } else {
        openMenu();
      }
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeMenu();
    });

    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
        closeMenu({ restoreFocus: true });
      }
    });

    desktopBreakpoint.addEventListener('change', (event) => {
      if (event.matches) closeMenu();
    });
  };

  const initializeHeaders = (root = document) => {
    root.querySelectorAll('[data-mobile-header]').forEach(initializeHeader);
  };

  initializeHeaders();

  document.addEventListener('shopify:section:load', (event) => {
    initializeHeaders(event.target);
  });
})();
